<template>
  <Modal @open="play" @close="pause">
    <div class="flex justify-center items-center w-full">
      <div
        class="relative w-full"
        :style="{ 'padding-bottom': `${(9 / 16) * 100}%` }"
      >
        <video
          class="absolute inset-0"
          ref="video"
          controls
          :src="require('../assets/videos/MEYLExperience_flight.mp4')"
        ></video>
      </div>
    </div>
    <template #trigger="{open}">
      <button @click="open">
        <div class="relative">
          <img :src="require(`../assets/video_poster.jpg`)" alt="" />
          <div
            class="pointer-events-none absolute inset-0 flex justify-center items-center"
          >
            <div
              class="bg-blue text-white w-20 h-20 p-4 rounded-full flex justify-center items-center"
            >
              <PlayIcon size="2x" fill="currentColor" class="ml-1" />
            </div>
          </div>
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from './Modal';
import { PlayIcon } from 'vue-feather-icons';

export default {
  components: {
    Modal,
    PlayIcon
  },
  methods: {
    play() {
      if (this.$refs.video.ended) {
        this.$refs.video.currentTime = 0;
      }
      this.$refs.video.play();
    },
    pause() {
      this.$refs.video.pause();
    }
  }
};
</script>
